import { useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";
import { LoginForm } from "@/components/deck/LoginForm";
import { DeckBar } from "@/components/deck/DeckBar";
import { InboxPanel } from "@/components/deck/InboxPanel";
import { IntakePanel } from "@/components/deck/IntakePanel";
import { GradesPanel } from "@/components/deck/GradesPanel";
import { RulesPanel } from "@/components/deck/RulesPanel";
import { LeadersPanel } from "@/components/deck/LeadersPanel";
import { HistoryPanel } from "@/components/deck/HistoryPanel";
import { BuildsPanel } from "@/components/builds/BuildsPanel";
import { ChangePasswordForm } from "@/components/deck/ChangePasswordForm";

export default function DeckPage() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(!!getToken());
  const [inboxOpen, setInboxOpen] = useState(false);
  const [pending, setPending] = useState(0);
  const [intakeOpen, setIntakeOpen] = useState(false);
  const [intakeCount, setIntakeCount] = useState(0);
  const [panel, setPanel] = useState(null);
  const [gradesCount, setGradesCount] = useState(0);

  useEffect(() => { document.title = "Atlantis Command Deck"; }, []);
  useEffect(() => {
    if (!getToken()) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setToken(null)).finally(() => setChecking(false));
  }, []);

  const logout = () => { setToken(null); setUser(null); };

  if (checking) return <div className="lg lg-login" data-testid="deck-loading" />;
  if (!user) return <LoginForm onLogin={setUser} />;
  if (user.must_change || panel === "account") return (
    <div className="lg lg-login">
      <ChangePasswordForm forced={user.must_change} onDone={(u) => { setUser(u); setPanel(null); }}
        onCancel={user.must_change ? logout : () => setPanel(null)} />
    </div>
  );
  return (
    <div className="lg">
      <DeckBar user={user} pending={pending} intake={intakeCount} grades={gradesCount}
        onAccount={() => setPanel("account")}
        onBuilds={() => { setPanel((p) => (p === "builds" ? null : "builds")); setInboxOpen(false); setIntakeOpen(false); }}
        onHistory={() => { setPanel((p) => (p === "history" ? null : "history")); setInboxOpen(false); setIntakeOpen(false); }}
        onLeaders={() => { setPanel((p) => (p === "leaders" ? null : "leaders")); setInboxOpen(false); setIntakeOpen(false); }}
        onInbox={() => { setInboxOpen((o) => !o); setIntakeOpen(false); setPanel(null); }}
        onIntake={() => { setIntakeOpen((o) => !o); setInboxOpen(false); setPanel(null); }}
        onGrades={() => { setPanel((p) => (p === "grades" ? null : "grades")); setInboxOpen(false); setIntakeOpen(false); }}
        onRules={() => { setPanel((p) => (p === "rules" ? null : "rules")); setInboxOpen(false); setIntakeOpen(false); }} onLogout={logout} />
      <iframe title="Command Deck" src="/legion/command-deck.html" className="lg-frame" style={{ top: 48, height: "calc(100vh - 48px)" }} data-testid="command-deck-frame" />
      <InboxPanel open={inboxOpen} onClose={() => setInboxOpen(false)} onCount={setPending} />
      <RulesPanel open={panel === "rules"} onClose={() => setPanel(null)} />
      {user.role === "owner" && <LeadersPanel open={panel === "leaders"} onClose={() => setPanel(null)} me={user} />}
      <HistoryPanel open={panel === "history"} onClose={() => setPanel(null)} />
      <BuildsPanel open={panel === "builds"} onClose={() => setPanel(null)} me={user} />
      <GradesPanel open={panel === "grades"} onClose={() => setPanel(null)} onCount={setGradesCount} />
      <IntakePanel open={intakeOpen} onClose={() => setIntakeOpen(false)} onCount={setIntakeCount} />
    </div>
  );
}
